module.exports = __webpack_public_path__ + "static/img/about-this-report-hero.528838f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/about-this-report-hero.jpg
// module id = eCRh
// module chunks = 0